import { ReferenceArrayInput, SelectArrayInput, ArrayField, SingleFieldList, ChipField } from 'react-admin';
import OpenSpecialtiesButton from './OpenSpecialtiesButton';

const widthInputs = { width: '260px' };

const UserProfessionalProfile = ({ edit }) => (
  <div style={{ marginTop: '16px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
    <label style={{ fontWeight: 'bold' }}>Perfil profissional</label>
    {!edit && (
      <ReferenceArrayInput
        reference="specialties"
        source="specialties.id"
        perPage={999}
        sort={{ field: 'name', order: 'ASC' }}
      >
        <SelectArrayInput
          style={widthInputs}
          label="Especialidade"
          optionText="name"
          optionValue="id"
        />
      </ReferenceArrayInput>
    )}
    {edit && (
      <>
        <label>Especialidades cadastradas</label>
        <ArrayField label="Especialidade" source="specialtiesUsers">
          <SingleFieldList linkType={false}>
            <ChipField source="specialties.name" />
          </SingleFieldList>
        </ArrayField>
        <OpenSpecialtiesButton action={edit} />
      </>
    )}
  </div>
);

export default UserProfessionalProfile;
